import * as React from 'react';
import * as styles from '../styles.scss';
import { DatePicker, Fallback } from 'components/common';
import { IState } from 'redux/global-reducers';
import * as classNames from 'classnames';
import { WithNamespaces, withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { handleError } from 'utils/common';
import { withErrorBoundary } from 'react-error-boundary';
import { IOrderForm, IOrderFormConfig, OrderFormFieldKey } from '../config';
import { FormikErrors } from 'formik';
import { formatStringToDate } from 'utils/datetime';

interface IStopTimeSectionProps
  extends React.ClassAttributes<StopTimeComponent>,
    WithNamespaces {
  readonly config: IOrderFormConfig;
  readonly values: IOrderForm;
  readonly onChangeStopTime: (date: Date) => void;

  readonly ErrorMessage: React.FC<{
    readonly message?: string;
  }>;
  readonly errors: FormikErrors<IOrderForm>;
}

class StopTimeComponent extends React.Component<IStopTimeSectionProps> {
  render() {
    const {
      t,
      config,
      ErrorMessage,
      errors,
      values,
      onChangeStopTime,
    } = this.props;
    return (
      <div
        className={classNames(styles.StopTimeSection, styles.FormField)}
        style={config[OrderFormFieldKey.STOP_TIME]?.style}
      >
        <div className={styles.MainField}>
          <div className={styles.FieldTitle}>{t('Stop Time')}</div>
          <div className={classNames(styles.FieldInput, styles.MarginTop16)}>
            <DatePicker
              onChange={onChangeStopTime}
              selected={
                values.stopTime
                  ? formatStringToDate(values.stopTime, 'HHmm')
                  : null
              }
              showTimeSelect={true}
              showTimeSelectOnly={true}
              timeIntervals={10}
              timeCaption={t('Time')}
              dateFormat="HH:mm"
            />
          </div>
        </div>

        <ErrorMessage message={errors.stopTime} />
      </div>
    );
  }
}

const mapStateToProps = (state: IState) => ({});

const mapDispatchToProps = {};

const StopTimeSection = withErrorBoundary(
  withNamespaces('common')(
    connect(mapStateToProps, mapDispatchToProps)(StopTimeComponent)
  ),
  Fallback,
  handleError
);

export default StopTimeSection;



// WEBPACK FOOTER //
// ./src/components/common/OrderForm/FormSection/StopTime.tsx